<template>
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines u-f u-jsb" :inline="true">
        <div>
          <el-form-item>
            <el-input placeholder="请输入用户名" v-model="input" clearable style="width: 200px; margin-right: 10px"
              size="small">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchUser">查询</el-button>
            <el-button type="success" size="small" @click="dialogFormVisible = true">新增</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" border :height="height" v-loading="loading">
      <el-table-column prop="username" label="用户名" align="center">
      </el-table-column>
      <el-table-column prop="username" label="用户" align="center">
        <template slot-scope="{row}">
          <span>ID:{{row.user_id}}&nbsp;&nbsp;用户:{{row.nickname}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="circle" label="圈子" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="select(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="添加时间" align="center">
      </el-table-column>
      <el-table-column prop="operate" label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit( scope.row)" type="primary">修改</el-button>
          <el-button size="mini" type="danger" @click="handleDelete( scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-f u-ac u-jsb ft_mr">
      <div></div>
      <div>
        <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
          :current-page="currentPage2" :page-sizes="[10]" :page-size="pagesize2"
          layout="total, sizes, prev, pager, next, jumper" :total="count2">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="新增版主" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="80px">
        <el-form-item label="用户" prop="user_id">
          <el-select filterable v-model="ruleForm.user_id" placeholder="请选择" style="max-width: 400px" size="small">
            <el-option v-for="item in ry_options" :key="item.id" :label="item.nickname" :value="item.user_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="ruleForm.username" autocomplete="off" size="small" style="max-width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" autocomplete="off" size="small" style="max-width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1" border>启用</el-radio>
            <el-radio :label="0" border>禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="圈子" :visible.sync="dialogTableVisible">
      <div style="margin-bottom: 10px">
        <!-- <el-input placeholder="请输入名称" v-model="circleValue" clearable style="width: 200px; margin-right: 10px"
          size="small">
        </el-input> -->
        <el-button type="primary" size="small" @click="beginqz">刷新</el-button>
      </div>
      <el-table :data="gridData" border v-loading='qzloading'>
        <el-table-column property="title" label="名称" align="center"></el-table-column>
        <el-table-column property="create_time" label="添加时间" align="center"></el-table-column>
        <el-table-column property="operate" label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleDeletetopic( scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
            layout="total, prev, pager, next, jumper" :total="count">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        //表格数据
        tableData: [],
        //查看
        gridData: [],

        //查看
        dialogTableVisible: false,
        //新增/修改
        dialogFormVisible: false,
        //新增
        ruleForm: {
          user_id: "",
          username: "",
          password: "",
          avatar: "",
          role_id: "33",
          status: 1,
        },
        rules: {
          name: [{
            required: true,
            message: "请输入用户",
            trigger: "blur"
          }],
          username: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }, ],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }],
        },
        //用户名查询
        input: "",
        //圈子查询
        circleValue: "",
        //总数
        count: 0,
        //当前页
        currentPage: 1,
        //每页数
        pagesize: 10,
        //新增用户
        ry_options: [],
        //总数
        count2: 0,
        //当前页
        currentPage2: 1,
        //每页数
        pagesize2: 10,
        height: null,
        loading: false,
        selectuserq_id: '',
        qzloading: false
      };
    },
    created() {
      this.getper();
      this.searchUser();
    },
    mounted() {
      this.getHeight()

    },
    methods: {
      getHeight() {
        let that = this
        var titles = that.$refs.titles.offsetHeight
        that.height = window.innerHeight - titles - 200 + 'px'
        window.onresize = () => {
          var titles = that.$refs.titles.offsetHeight
          that.height = window.innerHeight - titles - 200 + 'px'
        }
      },
      //修改
      handleEdit(row) {
        this.dialogFormVisible = true;
        this.ruleForm.user_id = row.user_id - 0
        this.ruleForm.username = row.username
        this.ruleForm.status = row.status

      },
      // 删除单个
      handleDelete(item) {
        this.$confirm('是否要删除该版主?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/admin/manager/' + item.id + '/delete', {}, {
            token: true
          }).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.searchUser();
          }).catch(err => {})
        })
      },
      //验证
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //成功
            let url = `/admin/manager`;
            this.axios
              .post(url, this.ruleForm, {
                token: true,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.dialogFormVisible = false
                  this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  this.searchUser();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              })
              .catch((err) => {});
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //查看
      beginqz() {
        this.currentPage = 1
        this.select()
      },
      select(a, b) {
        let that = this
        if (b) {
          this.selectuserq_id = b.id
        }
        this.dialogTableVisible = true;
        that.qzloading = true
        axios.get(
            `admin/topicclass/7/topic/${that.currentPage}?manager_id=${this.selectuserq_id}`, {
              token: true
            })
          .then(response => {
            that.qzloading = false
            that.gridData = response.data.data.list[1]
            that.count = response.data.data.list[0]
          })
          .catch(error => {})

      },
      handleDeletetopic(row, index) {
        let that = this
        that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios
            .post("/admin/deltopic", {
              id: row.id
            }, {
              token: true
            })
            .then(response => {
              if (response.data.code == '200') {
                that.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                that.select()
              } else {
                that.$message.error(response.data.message);
              }
            })
            .catch(error => {})

        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //每页(查看)
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
      },
      //当前页(查看)
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.select()
      },
      //每页(外面)
      handleSizeChange2(val) {
        this.pagesize2 = val;
        this.searchUser();
      },
      //当前页(外面)
      handleCurrentChange2(val) {
        this.currentPage2 = val;
        this.searchUser();
      },
      // 获取人员
      getper() {
        let that = this;
        axios
          .post(
            `/admin/communityDoctor/moderatorUser`, {}, {
              token: true,
            }
          )
          .then((response) => {
            that.ry_options = response.data.data;
          })
          .catch((error) => {});
      },
      //搜索表格数据
      searchUser() {
        this.loading = true
        let url = `/admin/manager/${this.currentPage2}?limit=${this.pagesize2}&keyword=${this.input}&role_id=33`;
        this.axios
          .get(url, {
            token: true,
          })
          .then((res) => {
            this.loading = false

            this.tableData = res.data.data.list;
            this.count2 = res.data.data.totalCount;
          })
          .catch((err) => {});
      },
    },
  };
</script>

<style>
</style>